import { render, staticRenderFns } from "./CheckpointInspectionBadge.vue?vue&type=template&id=73854261&scoped=true"
import script from "./CheckpointInspectionBadge.vue?vue&type=script&setup=true&lang=js"
export * from "./CheckpointInspectionBadge.vue?vue&type=script&setup=true&lang=js"
import style0 from "./CheckpointInspectionBadge.vue?vue&type=style&index=0&id=73854261&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../account/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73854261",
  null
  
)

export default component.exports